import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useUTMParams = () => {
  const location = useLocation();
  const [utmSource, setUtmSource] = useState(null);
  const [utmCampaign, setUtmCampaign] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setUtmSource(params.get('utm_source'));
    setUtmCampaign(params.get('utm_campaign'));
  }, [location.search]);

  return { utmSource, utmCampaign };
};

export default useUTMParams;
